import {PaymentReferenceMode} from '@/api'

export const ORDER_NUMBER_OPTIONS = [
    PaymentReferenceMode.FIXED,
    PaymentReferenceMode.PAYER_INPUT,
    PaymentReferenceMode.EDITABLE
]

export const ORDER_NUMBER_OPTION_TRANSLATION_KEYS = {
    [PaymentReferenceMode.FIXED]: 'fixed',
    [PaymentReferenceMode.PAYER_INPUT]: 'customerEnters',
    [PaymentReferenceMode.EDITABLE]: 'customerCanEdit'
}
